import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ErrorDisplay } from "../../SharedComponents/ErrorDisplay/ErrorDisplay";
import { ListLoading } from "../../SharedComponents/ListLoading/ListLoading";
import { Select, SelectOption } from "../../SharedComponents/Select/Select";
import { AccountancyReport } from "./AccountancyReport/AccountancyReport";
import "./AdminAccountancy.css";

export const AdminAccountancy = () => {
  const { t } = useTranslation();
  const { data, error, loading } = useQuery(getDistributorsQuery);
  const [selectedDistributor, setSelectedDistributor] = useState(null);
  const [distributorOptions, setDistrobutorOptions] = useState([]);

  useEffect(() => {
    if (
      !selectedDistributor &&
      data?.distributors &&
      data?.distributors?.length > 0
    ) {
      setSelectedDistributor(data?.distributors[0].id);

      setDistrobutorOptions(
        data?.distributors?.map((dist) => ({
          label: dist.name,
          value: dist.id,
        }))
      );
    }
  }, [data, selectedDistributor]);

  if (error) {
    return <ErrorDisplay error={error} />;
  }

  if (loading) {
    return <ListLoading />;
  }

  return (
    <div className="AdminAccountancy">
      <div className="AdminAccountancy__titlebar">
        {distributorOptions && selectedDistributor && (
          <div className="AdminAccountancy__titlebar-select">
            <Select
              type="editItem"
              change={(id) => {
                setSelectedDistributor(id);
              }}
              value={selectedDistributor}
            >
              {distributorOptions?.map(({ label, value }) => (
                <SelectOption value={value} key={value}>
                  {label}
                </SelectOption>
              ))}
            </Select>
          </div>
        )}
        <div className="AdminAccountancy__titlebar-item">
          {t("generic.from")}
        </div>
        <div className="AdminAccountancy__titlebar-item">{t("generic.to")}</div>
        <div className="AdminAccountancy__titlebar-item">
          {t("generic.usage")}
        </div>
        <div className="AdminAccountancy__titlebar-item">
          {t("generic.accounts")}
        </div>
        <div className="AdminAccountancy__titlebar-item">
          {t("generic.download")}
        </div>
      </div>

      {selectedDistributor && (
        <AccountancyReportList distributorId={selectedDistributor} />
      )}
    </div>
  );
};

const AccountancyReportList = ({ distributorId }) => {
  const { data, error, loading } = useQuery(distributorReportRangesQuery, {
    variables: {
      id: distributorId,
    },
  });

  if (error) {
    return <ErrorDisplay error={error} />;
  }

  if (loading) {
    return <ListLoading />;
  }

  return (
    <>
      {data?.distributorReportRanges?.map((range) => (
        <AccountancyReport
          key={range.id}
          fromDate={range.range.from}
          endDate={range.range.to}
          name={range.distributorName}
          distributorId={range.distributorId}
          usage={range.usage}
          accounts={range.accounts}
        />
      ))}
    </>
  );
};

const getDistributorsQuery = gql`
  query distributors {
    distributors {
      id
      name
    }
  }
`;

const distributorReportRangesQuery = gql`
  query distributorReportRanges($id: String) {
    distributorReportRanges(id: $id) {
      id
      range {
        from
        to
      }
      distributorName
      distributorId
      accounts
      usage
    }
  }
`;
